module.exports = __webpack_public_path__ + "static/media/hk.4a0f09ba.svg";